import React, { useState, useEffect, useCallback } from 'react';
import PageHero from '../components/PageHero';
import GetInvolved from '../components/GetInvolved';
import './Gallery.css';

/* ── Data ────────────────────────────────────────────────── */
const PHOTOS = [
  { id: 1,  image: 'https://images.unsplash.com/photo-1577896851231-70ef18881754?auto=format&fit=crop&w=700&h=500&q=80', tag: 'Education',   icon: '🎓', title: 'Digital literacy class, Villupuram',         year: '2024', bg: 'linear-gradient(135deg,#d1fae5,#a7f3d0)' },
  { id: 2,  image: 'https://images.unsplash.com/photo-1758691462482-2b6ccbaefa6e?auto=format&fit=crop&w=700&h=500&q=80', tag: 'Healthcare',  icon: '💊', title: 'Free eye camp — 200 surgeries in one day',   year: '2024', bg: 'linear-gradient(135deg,#fef3c7,#fde68a)' },
  { id: 3,  image: 'https://images.unsplash.com/photo-1759738099669-d64b0656f6cf?auto=format&fit=crop&w=700&h=500&q=80', tag: 'Women',       icon: '👩', title: 'SHG training — Tailoring batch, Salem',      year: '2023', bg: 'linear-gradient(135deg,#dbeafe,#bfdbfe)' },
  { id: 4,  image: 'https://images.unsplash.com/photo-1762884110133-926e4195d3b9?auto=format&fit=crop&w=700&h=500&q=80', tag: 'Farming',     icon: '🌾', title: 'Organic farming demo, Dindigul',              year: '2023', bg: 'linear-gradient(135deg,#d1fae5,#bbf7d0)' },
  { id: 5,  image: 'https://images.unsplash.com/photo-1698795635937-31264cdbf359?auto=format&fit=crop&w=700&h=500&q=80', tag: 'Children',    icon: '🧒', title: 'Nutrition centre — morning meal distribution', year: '2024', bg: 'linear-gradient(135deg,#fce7f3,#fbcfe8)' },
  { id: 6,  image: 'https://images.unsplash.com/photo-1497486751825-1233686d5d80?auto=format&fit=crop&w=800&h=500&q=80', tag: 'Rural',       icon: '🏘️', title: 'Community well inauguration, Erode',         year: '2022', bg: 'linear-gradient(135deg,#ede9fe,#ddd6fe)' },
  { id: 7,  image: 'https://images.unsplash.com/photo-1524069290683-0457abfe42c3?auto=format&fit=crop&w=700&h=500&q=80', tag: 'Education',   icon: '📚', title: 'Library inauguration — 500 books donated',   year: '2023', bg: 'linear-gradient(135deg,#cffafe,#a5f3fc)' },
  { id: 8,  image: 'https://images.unsplash.com/photo-1758691462123-8a17ae95d203?auto=format&fit=crop&w=700&h=500&q=80', tag: 'Healthcare',  icon: '🏥', title: 'Mobile medical van reaching tribal hamlet',   year: '2024', bg: 'linear-gradient(135deg,#fef9c3,#fef08a)' },
  { id: 9,  image: 'https://images.unsplash.com/photo-1709200306040-4dd19b43a47a?auto=format&fit=crop&w=700&h=500&q=80', tag: 'Women',       icon: '🤝', title: 'Women entrepreneurs market fair, Tirunelveli', year: '2024', bg: 'linear-gradient(135deg,#e0f2fe,#bae6fd)' },
  { id: 10, image: 'https://images.unsplash.com/photo-1593441210222-6543b1c1fffb?auto=format&fit=crop&w=700&h=500&q=80', tag: 'Farming',     icon: '💧', title: 'Rainwater harvesting check-dam, Erode',      year: '2022', bg: 'linear-gradient(135deg,#dcfce7,#bbf7d0)' },
  { id: 11, image: 'https://images.unsplash.com/photo-1617878227827-8360231f7f03?auto=format&fit=crop&w=700&h=500&q=80', tag: 'Children',    icon: '🎨', title: 'Art therapy session, Child Friendly Space',  year: '2023', bg: 'linear-gradient(135deg,#fef2f2,#fecaca)' },
  { id: 12, image: 'https://images.unsplash.com/photo-1685023620523-9c726f2c499b?auto=format&fit=crop&w=700&h=500&q=80', tag: 'Rural',       icon: '💡', title: 'Solar street light installation, tribal area', year: '2023', bg: 'linear-gradient(135deg,#fefce8,#fef08a)' },
  { id: 13, image: 'https://images.unsplash.com/photo-1542810634-71277d95dcbb?auto=format&fit=crop&w=700&h=500&q=80', tag: 'Education',   icon: '🖥️', title: 'Computer lab launch — Govt. HS Sirugur',     year: '2022', bg: 'linear-gradient(135deg,#f0fdf4,#dcfce7)' },
  { id: 14, image: 'https://images.unsplash.com/photo-1631815590058-860e4f83c1e8?auto=format&fit=crop&w=700&h=500&q=80', tag: 'Healthcare',  icon: '🩺', title: 'Maternal health camp, Villupuram',            year: '2023', bg: 'linear-gradient(135deg,#fffbeb,#fde68a)' },
  { id: 15, image: 'https://images.unsplash.com/photo-1708417134243-6d71770d82ef?auto=format&fit=crop&w=700&h=500&q=80', tag: 'Women',       icon: '🧵', title: 'Fabric dyeing micro-enterprise launch',       year: '2024', bg: 'linear-gradient(135deg,#f5f3ff,#ddd6fe)' },
  { id: 16, image: 'https://images.unsplash.com/photo-1779116244012-b7a10e99fd6a?auto=format&fit=crop&w=700&h=500&q=80', tag: 'Farming',     icon: '🌱', title: 'Seed distribution for organic farmers',       year: '2024', bg: 'linear-gradient(135deg,#ecfdf5,#a7f3d0)' },
  { id: 17, image: 'https://images.unsplash.com/photo-1643804539650-27c44544e986?auto=format&fit=crop&w=700&h=500&q=80', tag: 'Children',    icon: '⚽', title: 'Sports day at residential welfare centre',    year: '2023', bg: 'linear-gradient(135deg,#fdf4ff,#e9d5ff)' },
  { id: 18, image: 'https://images.unsplash.com/photo-1549780100-a15a819b8ac5?auto=format&fit=crop&w=700&h=500&q=80', tag: 'Rural',       icon: '🚰', title: 'Clean water pipeline — 12 villages connected', year: '2022', bg: 'linear-gradient(135deg,#eff6ff,#bfdbfe)' },
];

const VIDEOS = [
  { icon: '🎬', duration: '3:42', title: 'Our 2024 Impact in 3 Minutes', desc: 'A year in review — stories, numbers, and the faces behind our work.', bg: 'linear-gradient(135deg,#0a3d39,#0F766E)' },
  { icon: '🌱', duration: '5:10', title: 'How Rainwater Harvesting Changed Erode', desc: '12 villages, 8 crore litres of water stored, and zero dry summers ahead.', bg: 'linear-gradient(135deg,#1e3a1e,#16a34a)' },
  { icon: '👩', duration: '4:28', title: "Meena's Story — From SHG Member to Entrepreneur", desc: 'How one self-help group member built a thriving tailoring business in Tirunelveli.', bg: 'linear-gradient(135deg,#1e1b4b,#4338ca)' },
];

const CATEGORIES = ['All', 'Education', 'Healthcare', 'Women', 'Farming', 'Children', 'Rural'];
const PAGE_SIZE = 12;

/* ── Lightbox ────────────────────────────────────────────── */
function Lightbox({ photos, index, onClose, onPrev, onNext }) {
  const photo = photos[index];

  useEffect(() => {
    const onKey = e => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose, onPrev, onNext]);

  return (
    <div
      className="lightbox-backdrop"
      role="dialog"
      aria-modal="true"
      aria-label={`Photo: ${photo.title}`}
      onClick={e => e.target === e.currentTarget && onClose()}
    >
      <div className="lightbox-inner">
        <button className="lightbox-close" onClick={onClose} aria-label="Close lightbox">✕</button>
        <button className="lightbox-nav lightbox-prev" onClick={onPrev} aria-label="Previous photo">‹</button>
        <button className="lightbox-nav lightbox-next" onClick={onNext} aria-label="Next photo">›</button>

        <div className="lightbox-img-wrap">
          <img src={photo.image} alt={photo.title} className="lightbox-photo" />
        </div>

        <div className="lightbox-info">
          <div className="lightbox-info-tag">{photo.tag}</div>
          <div className="lightbox-info-title">{photo.title}</div>
          <div className="lightbox-info-meta">{photo.year}</div>
        </div>

        <div className="lightbox-counter" aria-live="polite">
          {index + 1} / {photos.length}
        </div>
      </div>
    </div>
  );
}

/* ── Main component ──────────────────────────────────────── */
export default function Gallery() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const filtered = activeCategory === 'All'
    ? PHOTOS
    : PHOTOS.filter(p => p.tag === activeCategory);

  const visible = filtered.slice(0, visibleCount);

  const openLightbox = i => setLightboxIndex(i);
  const closeLightbox = useCallback(() => setLightboxIndex(null), []);
  const prevPhoto = useCallback(() => setLightboxIndex(i => (i - 1 + filtered.length) % filtered.length), [filtered.length]);
  const nextPhoto = useCallback(() => setLightboxIndex(i => (i + 1) % filtered.length), [filtered.length]);

  const handleCategoryChange = cat => {
    setActiveCategory(cat);
    setVisibleCount(PAGE_SIZE);
  };

  return (
    <main id="main-content">
      <PageHero
        label="Gallery"
        title="Moments of Change, Captured"
        desc="Photos and videos from our field programmes — real moments, real people, real impact across 120+ villages."
        breadcrumb="Gallery"
        bgImage="https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1600&h=600&q=80"
      />

      {/* Filter bar */}
      <div className="gallery-filter-bar" role="navigation" aria-label="Filter gallery by category">
        <div className="container">
          <div className="gallery-filter-inner">
            <div className="gallery-filter-tabs" role="list">
              {CATEGORIES.map(cat => (
                <button
                  key={cat}
                  className={`gallery-filter-tab${activeCategory === cat ? ' active' : ''}`}
                  onClick={() => handleCategoryChange(cat)}
                  aria-pressed={activeCategory === cat}
                >
                  {cat}
                </button>
              ))}
            </div>
            <span className="gallery-count-label" aria-live="polite">
              {filtered.length} photo{filtered.length !== 1 ? 's' : ''}
            </span>
          </div>
        </div>
      </div>

      {/* Photo grid */}
      <section className="gallery-section section" aria-label="Photo gallery">
        <div className="container">
          {filtered.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '4rem 0', color: 'var(--gray-400)' }}>
              No photos in this category yet.
            </div>
          ) : (
            <>
              <div className="gallery-grid" role="list">
                {visible.map((photo, idx) => (
                  <div
                    key={photo.id}
                    className="gallery-item"
                    role="listitem"
                    onClick={() => openLightbox(idx)}
                    onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && openLightbox(idx)}
                    tabIndex={0}
                    aria-label={`${photo.title} — ${photo.tag}, ${photo.year}. Press Enter to enlarge.`}
                  >
                    <div className="gallery-item-img">
                      <img src={photo.image} alt={photo.title} className="gallery-photo" loading="lazy" />
                    </div>
                    <div className="gallery-item-overlay" aria-hidden="true">
                      <div className="gallery-item-zoom">⤢</div>
                      <div className="gallery-item-caption">
                        <div className="gallery-item-tag">{photo.tag}</div>
                        <div className="gallery-item-title">{photo.title}</div>
                        <div className="gallery-item-year">{photo.year}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {visibleCount < filtered.length && (
                <div className="gallery-load-more">
                  <button
                    className="btn btn-outline"
                    onClick={() => setVisibleCount(n => n + PAGE_SIZE)}
                  >
                    Load More Photos ({filtered.length - visibleCount} remaining)
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </section>

      {/* Video section */}
      <section className="gallery-videos section" aria-labelledby="videos-heading">
        <div className="container">
          <div className="section-header">
            <span className="section-label">Watch & Be Inspired</span>
            <h2 className="section-title" id="videos-heading">Stories in Motion</h2>
            <p className="section-subtitle">
              Short films from our field teams — capturing the spirit of communities we work with.
            </p>
          </div>

          <div className="videos-grid" role="list">
            {VIDEOS.map(v => (
              <div
                className="video-card"
                key={v.title}
                role="listitem"
                tabIndex={0}
                aria-label={`Play video: ${v.title}, duration ${v.duration}`}
              >
                <div className="video-thumb" style={{ background: v.bg }}>
                  <span aria-hidden="true" style={{ fontSize: '3rem', opacity: 0.5 }}>{v.icon}</span>
                  <div className="video-play-btn" aria-hidden="true">▶</div>
                </div>
                <div className="video-info">
                  <div className="video-duration">{v.duration}</div>
                  <div className="video-title">{v.title}</div>
                  <div className="video-desc">{v.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightboxIndex !== null && (
        <Lightbox
          photos={visible}
          index={lightboxIndex}
          onClose={closeLightbox}
          onPrev={prevPhoto}
          onNext={nextPhoto}
        />
      )}

      <GetInvolved />
    </main>
  );
}
